module.exports = __webpack_public_path__ + "static/media/ASB6000 - 3.de346ba8.jpeg";